import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { checkBox, constantField, Form } from "trader.ts/ui.forms";
import {
  formulaInvoicelinesForm,
  singleDueDateCalculationField,
} from "../../client/financialfields";
import { renderSaveButton } from "../../client/savebutton";
import { singleDueDateCalculation } from "../../parsing_from_ur";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import { invoicelineEachPeriod } from "../../domain/finance/types";
import { country } from "../../domain/config";
import { price_adapted_to_lg } from "../../../sql/classy/types";

export function render(opts: {
  eachPeriodInvoiceLines: invoicelineEachPeriod[];
  dueDateCalc: singleDueDateCalculation;
  hasOnlinePayments: boolean;
  payDuringOnlineEnrollment: boolean;
  country: country;
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("eachPeriodInvoiceLines", [], async () =>
      formulaInvoicelinesForm<price_adapted_to_lg>(
        opts.eachPeriodInvoiceLines
          .orderBy((il) => (il.type_ === "Normal" ? 1 : 2), "asc")
          .map((il) => ({ ...il, chargemode: "Enrollment" })),
        {
          allowedTypes: ["Normal", "Discount"],
          allowedChargemodes: ["Enrollment"],
          country: opts.country,
          small: false,
        },
      ),
    )
    .addField("dueDateCalc", [], async () =>
      singleDueDateCalculationField({
        initialVal: opts.dueDateCalc,
        label: "Betaaldatum",
      }),
    )
    .addField("payDuringOnlineEnrollment", [], async () =>
      opts.hasOnlinePayments
        ? checkBox({
            initialVal: opts.payDuringOnlineEnrollment,
            class: style.checkbox + style.input_like,
            label: "Betaal tijdens online inschrijving",
          })
        : constantField(false),
    )
    .build({
      render: (fields) => (
        <div>
          <section>{fields.eachPeriodInvoiceLines()}</section>

          {opts.hasOnlinePayments ? (
            <label for="">{"Online"}</label>
          ) : (
            <span></span>
          )}
          {fields.payDuringOnlineEnrollment()}

          {fields.dueDateCalc()}
        </div>
      ),
    });

  return (
    <div>
      {form.render()}
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) => {
            return rpc(
              routes.saveEachPeriodFinancialConfigSpec,
              undefined,
              values,
            );
          },
          timeout: 2000,
          reload: true,
        })}
      </div>
    </div>
  );
}
